import { useState } from 'react'
import { MenuLinks } from '../../../../../constants'
import { authButtonHandlerFactory } from '../../../../services/auth-utils'
import SignInModal from '../../../sign-in-modal'
import { useLocation } from 'react-router-dom'
import { BodyTextContainer, Button, ContentContainer, Heading } from '@msaf/core-react'

export default function SessionTimeout() {
  const location = useLocation()
  const [isSignInModalOpen, setIsSignInModalOpen] = useState(false)
  return (
    <>
      <SignInModal isOpen={isSignInModalOpen} closeModal={() => setIsSignInModalOpen(false)} />
      <ContentContainer>
        <BodyTextContainer>
          <Heading level={1}>You are not signed-in</Heading>
          <p>Please sign in to continue using the app.</p>
          <p>
            Please <a href={MenuLinks.CONTACT_US}>contact us</a> if you are facing problems signing into the app.
          </p>
          <p>
            <Button
              buttonStyle='primary'
              label='Sign in'
              onClick={authButtonHandlerFactory(location.pathname, setIsSignInModalOpen)}
            />
          </p>
        </BodyTextContainer>
      </ContentContainer>
    </>
  )
}
